import InitClassLogic from "./Class.logic";
import styles from "./Class.module.css"

const ClassComponent: React.FC = () => {
    const { selectedClients, clients, data, trainingTypeRef, categories, onSave, onChange, addClient, removeSelectedClient } = InitClassLogic();

    const getCounterForClient = (client: any, categoryId: number) => {
        const counter = client.counters?.find((c: any) => c.trainingCategoryId === categoryId);
        return counter ? counter.counter : 0;
    };

    const selectedCategoryId = +data.trainingType;

    return (
        <div className="page-container">
            <h1 className="text-align-center">Evidencija treninga</h1>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                <button className="btn-primary" type="button" onClick={onSave}>Sačuvaj</button>

                <div>
                    <label htmlFor="trainingType">Tip treninga</label>
                    <select id="trainingType" aria-label={"Izaberi tip treninga"} ref={trainingTypeRef} onChange={onChange} name="trainingType" value={data.trainingType}>
                        {categories.map((c) => (
                            <option key={c.id} value={c.id}>{c.name}</option>
                        ))}
                    </select>
                </div>

                <div>
                    <label htmlFor="client">Pretraga klijenata</label>
                    <input placeholder="Traži po imenu ili prezimenu..." id="client" type={"text"} value={data.client} onChange={onChange} name="client"></input>
                </div>
            </div>

            {selectedClients.length > 0 && (
                <div className="card" style={{ marginTop: '16px' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                        {selectedClients.map((c) => {
                            const counter = getCounterForClient(c, selectedCategoryId);
                            return (
                                <button className={counter < 2 ? styles.red : "btn-secondary"} type="button" key={c.id} onClick={() => removeSelectedClient(c)}>{c.firstName} {c.lastName} [{counter}]</button>
                            );
                        })}
                    </div>
                </div>
            )}

            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginTop: '12px' }}>
                {clients.map((c) => {
                    const counter = getCounterForClient(c, selectedCategoryId);
                    return c.firstName.concat(" ", c.lastName).toLowerCase().replaceAll("ć", "c").replaceAll("č", "c").replaceAll("š", "s").replaceAll("ž", "z").replaceAll("đ", "dj").includes(data.client.toLowerCase().replaceAll("ć", "c").replaceAll("č", "c").replaceAll("š", "s").replaceAll("ž", "z").replaceAll("đ", "dj")) ? (
                        <button className={counter < 2 ? styles.red : ""} type="button" key={c.id} onClick={() => addClient(c)}>{c.firstName} {c.lastName} [{counter}]</button>
                    ) : "";
                })}
            </div>

            <div style={{ marginTop: '16px' }}>
                <button className="btn-primary" type="button" onClick={onSave}>Sačuvaj</button>
            </div>
        </div>
    );
}

export default ClassComponent;
